export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  // Revoked on the next frame: revoking synchronously can cancel the download
  // before the browser has read the blob.
  requestAnimationFrame(() => URL.revokeObjectURL(url));
}
